import { useState, useEffect } from "react";
import { FaEnvelope, FaLock, FaUser, FaTimes } from "react-icons/fa";
import Loader from "../components/loader";
import emailjs from "@emailjs/browser";
import { v4 as uuidv4 } from "uuid";
import "./OwnerAddAdmin.css";

export default function OwnerAddAdminModal({ onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [verificationToken, setVerificationToken] = useState(null);
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    let interval;
    if (showVerifyModal && timer > 0) {
      interval = setInterval(() => setTimer((t) => t - 1), 1000);
    } else if (timer === 0) {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [showVerifyModal, timer]);

  const sendVerificationEmail = async (name, email, token) => {
    const link = `${window.location.origin}/verify-email/${token}`;
    await emailjs.send(
      "service_5u1kekh",
      "template_3j87dpi",
      { to_name: name, user_email: email, verification_link: link },
      "5C9M_B-DFS8qIhtRl"
    );
  };

  const handleResend = async () => {
    if (!canResend) return;
    setTimer(30);
    setCanResend(false);
    await sendVerificationEmail(formData.name, formData.email, verificationToken);
  };

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      return setError("Passwords do not match");
    }
    setLoading(true);
    setError("");

    try {
      const userId = uuidv4().replace(/-/g, "").slice(0, 16);
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/admin/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formData, userId }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Signup failed");

      if (data.verificationToken) {
        setVerificationToken(data.verificationToken);
        localStorage.setItem("verificationRole", "admin");
        localStorage.setItem("verificationEmail", formData.email);
        await sendVerificationEmail(formData.name, formData.email, data.verificationToken);
        setShowVerifyModal(true);
      }
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="add-admin-overlay">
      <div className="add-admin-card">
        <FaTimes className="add-admin-close" onClick={onClose} />
        
        {showVerifyModal ? (
          <div className="add-admin-verify">
            <h3 className="add-admin-title">Verify New Admin</h3>
            <p>Verification link sent to <b>{formData.email}</b></p>
            <button disabled={!canResend} onClick={handleResend} className="add-admin-btn">
              {canResend ? "Resend Email" : `Resend (${timer}s)`}
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <h2 className="add-admin-title">Add New Admin</h2>
            <div className="add-admin-input">
              <FaUser />
              <input name="name" placeholder="Admin Name" onChange={handleChange} required />
            </div>
            <div className="add-admin-input">
              <FaEnvelope />
              <input name="email" type="email" placeholder="Admin Email" onChange={handleChange} required />
            </div>
            <div className="add-admin-input">
              <FaLock />
              <input name="password" type="password" placeholder="Password" onChange={handleChange} required />
            </div>
            <div className="add-admin-input">
              <FaLock />
              <input name="confirmPassword" type="password" placeholder="Confirm Password" onChange={handleChange} required />
            </div>
            {error && <p className="add-admin-error">{error}</p>}
            <button className="add-admin-btn">Create Admin</button>
          </form>
        )}
      </div>
    </div>
  );
}